import React from 'react';
import cn from 'classnames';

import TimeOffSplashStartFreeTrial from 'components/hr/timeOffSplash/TimeOffSplashStartFreeTrial.component';
import UpgradePlanButton from 'components/hr/timeOffSplash/UpgradePlanButton.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import C from 'utils/values/constant.util';

import CN from './TimeOffSplashPlanBenefitsPanel.module.scss';

const determineBenefits = (t) =>
  C([
    t('humanResources.splashOverview.planBenefitsSection.benefits.bullet1'),
    t('humanResources.splashOverview.planBenefitsSection.benefits.bullet2'),
    t('humanResources.splashOverview.planBenefitsSection.benefits.bullet3'),
    t('humanResources.splashOverview.planBenefitsSection.benefits.bullet4'),
    t('humanResources.splashOverview.planBenefitsSection.benefits.bullet5'),
  ]);

const determineFutureBenefits = (t) =>
  C([
    t('humanResources.splashOverview.planBenefitsSection.futureBenefits.bullet1'),
    t('humanResources.splashOverview.planBenefitsSection.futureBenefits.bullet2'),
    t('humanResources.splashOverview.planBenefitsSection.futureBenefits.bullet3'),
    t('humanResources.splashOverview.planBenefitsSection.futureBenefits.bullet4'),
    t('humanResources.splashOverview.planBenefitsSection.futureBenefits.bullet5'),
  ]);

const TimeOffSplashPlanBenefitsPanel = ({ variant, showTrialButton }) => {
  const { t } = useTranslation();

  const benefits = determineBenefits(t);
  const futureBenefits = determineFutureBenefits(t);

  const componentClasses = cn({ [CN.topLabel]: true, [CN[`${variant}Variant`]]: variant });

  return (
    <div data-bem="TimeOffSplashPlanBenefitsPanel" className={CN.card}>
      <div data-bem="TimeOffSplashPlanBenefitsPanel__label" className={CN.cardBanner}>
        <span className={componentClasses} role="img" aria-labelledby="Winner">
          {S.trophy} {t('humanResources.splashOverview.planBenefitsSection.advancedPlan')}
        </span>
      </div>

      {benefits.map((text) => (
        <div className={CN.listItem} key={text}>
          {text}
        </div>
      ))}

      <span className={CN.miniBanner} role="img" aria-labelledby="Coming Soon">
        {S.megaphone} {t('humanResources.splashOverview.planBenefitsSection.comingSoon')}
      </span>

      {futureBenefits.map((text) => (
        <div className={CN.listItem} key={text}>
          {text}
        </div>
      ))}

      <div data-bem="TimeOffSplashPlanBenefitsPanel__buttonContainer" className={CN.buttonContainer}>
        <UpgradePlanButton text={t('humanResources.splashOverview.planBenefitsSection.upgradeButton')} />
        {fromAnyToBool(showTrialButton) && <TimeOffSplashStartFreeTrial />}
      </div>
    </div>
  );
};

export default TimeOffSplashPlanBenefitsPanel;
